export const urls = {
  fileFormats:
    'https://www.notion.so/d3b/File-Extensions-and-Formats-bcc58a2cb9844d2b91d0cddcd5378dbd',
  expeditedFiles:
    'https://www.notion.so/d3b/Expedited-File-Types-and-Guidelines-fc5bd4390fa54de5a70b550d73779de9',
};
